import React from 'react';

export default class TextInput extends React.Component {

    constructor(props) {
        super(props);
    }

    getValue() {
        return this.props.value || '';
    }

    setValue(v) {
        this.props.onChange(v);
    }

    render() {
        if (this.props.type == 'textarea') {
            return (
                <div className="input-wrapper">
                    <label htmlFor={this.props.id}> {this.props.label} </label>
                    <textarea id={this.props.id} className="form-control" rows={this.props.rows}
                              value={this.getValue()}
                              onChange={(e)=>this.setValue(e.target.value)}
                              placeholder={this.props.placeholder}
                              disabled={!!this.props.disabled}>
                    </textarea>
                </div>
            );
        }
        
        return (
            <div className="input-wrapper">
                <label htmlFor={this.props.id}
                       className="control-label">{this.props.label}</label>
                <input type="text" className="form-control" id={this.props.id}
                       value={this.getValue()}
                       onChange={(e)=>this.setValue(e.target.value)}
                       placeholder={this.props.placeholder}
                       disabled={!!this.props.disabled}
                />
            </div>
        );
    }
}